export const CALENDAR_STEP_ROUTE = 'wybor-terminu';
export const CALENDAR_STEP_PARAMETRIZED_ROUTE = ':id/wybor-terminu';
